var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSellin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 4.66663H12.6666C13.0348 4.66663 13.3333 4.96509 13.3333 5.33329V14C13.3333 14.3682 13.0348 14.6666 12.6666 14.6666H3.33325C2.96505 14.6666 2.66658 14.3682 2.66658 14V5.33329C2.66658 4.96509 2.96505 4.66663 3.33325 4.66663Z",
    stroke: "#2A3D4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 6.00004V3.66671C10.3333 2.37804 9.28859 1.33337 7.99992 1.33337C6.71125 1.33337 5.66659 2.37804 5.66659 3.66671V6.00004",
    stroke: "#2A3D4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 10L10.6667 10",
    stroke: "#2A3D4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 8L5.33325 10L7.33325 12",
    stroke: "#2A3D4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellin);
export default __webpack_public_path__ + "static/media/sellin.daca41757f6b79398e075842347abd4d.svg";
export { ForwardRef as ReactComponent };